import styled from 'styled-components';

export const FooterContainer = styled.footer`
  background: url('/back_imgs/footer.png') no-repeat center center, var(--primary-color);
  background-size: cover;
  color: var(--light-text);
  padding: 4rem 0 0;

  @media (max-width: 768px) {
    padding: 3rem 0 0;
  }
`;

export const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const FooterColumn = styled.div`
  p {
    margin-bottom: 1.5rem;
    opacity: 0.8;
    line-height: 1.6;
  }
`;

export const FooterLogo = styled.div`
  margin-bottom: 1.5rem;

  h2 {
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0;
  }

  p {
    font-size: 1rem;
    margin: 0.3rem 0 0;
    opacity: 0.9;
  }
`;

export const FooterTitle = styled.h3`
  font-size: 1.3rem;
  margin-bottom: 1.5rem;
  position: relative;
  padding-bottom: 0.8rem;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 50px;
    height: 2px;
    background-color: var(--accent-color);
  }
`;

export const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const FooterLink = styled.li`
  margin-bottom: 0.8rem;

  a {
    color: var(--light-text);
    opacity: 0.8;
    transition: opacity 0.3s ease, transform 0.3s ease;
    display: inline-block;

    &:hover {
      opacity: 1;
      transform: translateX(5px);
    }
  }
`;

export const FooterContact = styled.div`
  margin-top: 0.5rem;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;

  svg {
    margin-right: 1rem;
    font-size: 1.2rem;
    margin-top: 0.2rem;
    color: var(--accent-color);
  }

  span {
    opacity: 0.8;
    line-height: 1.5;
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
`;

export const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: var(--light-text);
  font-size: 1.2rem;
  transition: background-color 0.3s ease, transform 0.3s ease;

  &:hover {
    background-color: var(--accent-color);
    transform: translateY(-3px);
  }
`;

export const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 3rem;
  padding: 1.5rem 0;
  text-align: center;
`;

export const Copyright = styled.p`
  font-size: 0.9rem;
  opacity: 0.7;
  margin: 0;
`;